<div class="main-page consultas">
    <div class="container-fluid">
        <!-- LINHA TITULO + PESQUISA -->

        <div class="row align-items-center">
            <div class="col-12 my-2">
                <h1>
                    <a class="btn btn-voltar text-center mr-2" (click)="this.router.navigate(['/consultations'])" data-title="Voltar"><i
                            class="fas fa-arrow-left"></i></a>
                    Consultar Sensor
                </h1>
            </div>
        </div>

        <!-- <mat-progress-bar mode="indeterminate" *ngIf="loader"></mat-progress-bar> -->

        <div *ngIf="retornoEntidades?.data?.length === 0 && !loader && !filter && !filterPlaca">
            <div class="row no-gutters mt-3">
                <p>Nenhum registro at&eacute; o momento...</p>
            </div>
            <div class="row no-gutters mt-3">
                <a (click)="this.router.navigate(['/sensor/create'])" mat-button color="primary"
                    class="btn ml-0 ml-sm-2 ml-md-3 btn-salvar my-2 my-md-0">
                    Criar um novo Sensor
                </a>
            </div>
        </div>

        <!-- Campos de Filtro - Sempre Visíveis -->
        <div class="row no-gutters mt-3">
            <div class="mat-elevation table-content">
                <div fxLayout fxLayoutAlign="center center" fxLayoutGap="10px">
                    <mat-form-field fxFlex="40%" class="ml-2">
                     <mat-label>Filtrar por Código do Sensor</mat-label>
                     <input matInput autocomplete="off"
                     (keyup)="this.applyFilter($event, 'codigoSensor')" 
                     style="text-transform: uppercase;" 
                     placeholder="Digite o código do sensor..."
                     #codigoInput>
                   </mat-form-field>
                   
                   <mat-form-field fxFlex="40%" class="ml-2">
                     <mat-label>Filtrar por Placa</mat-label>
                     <input matInput autocomplete="off"
                     (keyup)="this.applyFilter($event, 'placa')" 
                     style="text-transform: uppercase;" 
                     placeholder="Digite a placa..."
                     #placaInput>
                   </mat-form-field>
           
                </div>         

                <!-- (matSortChange)="handleSort($event)" -->

                <table mat-table [dataSource]="retornoEntidades" matSort class="mat-elevation-z8" *ngIf="retornoEntidades?.data?.length > 0">
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                    </ng-container>

                    <ng-container matColumnDef="codigoSensor">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Codigo Sensor
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.codigoSensor }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="nome">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Empresa/Filial/Divisão
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.nome }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="placa">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Placa
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.placa }}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="update">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <span class="alerta mr-2" data-title="Editar"
                                *ngIf="this.permissionService.hasPermission('SENSOR_ATUALIZACAO_FUNCIONALIDADE', this.permissions)" matTooltip="Editar">
                                <a (click)="this.router.navigate(['/sensor/edit/' + element.id])" class="btn btn-link">
                                    <img height="20" src="assets/img/edit.svg" alt="" />
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="clone">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <span class="alerta mr-2" data-title="Duplicar"
                                *ngIf="this.permissionService.hasPermission('SENSOR_ATUALIZACAO_FUNCIONALIDADE', this.permissions)" matTooltip="Duplicar">
                                <a (click)="this.router.navigate(['/sensor/clone/' + element.id])" class="btn btn-link">
                                    <img height="20" src="assets/img/duplic.svg" alt="" />
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="view">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <span class="alerta mr-2" data-title="Visualizar"
                                *ngIf="this.permissionService.hasPermission('SENSOR_ATUALIZACAO_FUNCIONALIDADE', this.permissions)" matTooltip="Visualizar">
                                <a (click)="this.router.navigate(['/sensor/view/' + element.id])" class="btn btn-link">
                                    <img height="20" src="assets/img/view.svg" alt="" />
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <button (click)="handleDelete(element)" class="btn btn-link"
                                *ngIf="this.permissionService.hasPermission('SENSOR_DELECAO_FUNCIONALIDADE', this.permissions)" matTooltip="Apagar">
                                <img height="20" src="assets/img/trash-cadastro.svg" alt="" />
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
                <mat-paginator 
                    [pageSizeOptions]="[10, 20, 40, 100]" 
                    [pageSize]="pageSize"
                    [length]="length"
                    [pageIndex]="currentPage"
                    (page)="handlePageChanged($event)"
                    showFirstLastButtons
                    *ngIf="retornoEntidades?.data?.length > 0">
                </mat-paginator>  
                
                <!-- Mensagem quando não há resultados -->
                <div *ngIf="retornoEntidades?.data?.length === 0 && !loader" class="text-center p-4">
                    <p class="text-muted">Nenhum sensor encontrado com os filtros aplicados.</p>
                    <p class="text-muted">Tente ajustar os filtros ou limpar os campos para ver todos os sensores.</p>
                </div>
                </div>
        </div>
    </div>
</div>
